<div class="dialog-content-container">
    <div class="message-content mx-auto px-4">

        @switch (state()) {

            <!-- Ask: no usable check on record -->
            @case ("ask") {
                <div class="pt-5 text-center">
                    <i class="pi pi-shield text-3xl text-primary mb-3 block"></i>
                    <h3 class="m-0 mb-2">{{ "QUOTE.CREDIT_CHECK.STEP_TITLE" | translate }}</h3>
                    <div class="subtext">{{ "QUOTE.CREDIT_CHECK.STEP_SUBTEXT" | translate }}</div>
                </div>
                <div class="py-5 flex justify-content-center flex-wrap gap-2">
                    <p-button [label]="declineLabelKey() | translate" [text]="true" (onClick)="onProceed()" />
                    <p-button [label]="'QUOTE.CREDIT_CHECK.RUN_NOW' | translate" (onClick)="runCheck()" />
                </div>
            }

            <!-- Running -->
            @case ("running") {
                <div class="py-6 flex flex-column align-items-center gap-3">
                    <p-progressSpinner styleClass="w-3rem h-3rem" strokeWidth="4" />
                    <span>{{ "QUOTE.CREDIT_CHECK.RUNNING" | translate }}</span>
                </div>
            }

            <!-- Approved -->
            @case ("approved") {
                <div class="pt-5">
                    <app-quote-credit-check-status [check]="creditCheck()" [currentTotal]="currentTotal()" />
                    <!-- Without the facts below it the tag alone is a very quiet way to say the
                         check passed, so spell out that the flow may continue. -->
                    <div class="subtext mt-2">{{ "QUOTE.CREDIT_CHECK.APPROVED_MESSAGE" | translate }}</div>
                </div>
                <div class="py-5 flex justify-content-center">
                    <p-button [label]="'QUOTE.CREDIT_CHECK.CONTINUE' | translate" icon="pi pi-arrow-right"
                              iconPos="right" (onClick)="onProceed()" />
                </div>
            }

            <!-- Denied -->
            @case ("denied") {
                <div class="pt-5">
                    <!-- Reasons live in the message below rather than above it: two separate blocks
                         of red text for one denial read as two problems. -->
                    <app-quote-credit-check-status [check]="creditCheck()" [currentTotal]="currentTotal()"
                                                   [showDenialReasons]="false" />
                    <p-message severity="error" styleClass="w-full mt-3">
                        <div class="flex flex-column gap-2">
                            @if (creditCheck(); as cc) {
                                @if (deniedByScore()) {
                                    <span>{{ "QUOTE.CREDIT_CHECK.DENIED_REASON_SCORE" | translate: {
                                        score: cc.creditScore, minimum: cc.minimumCreditScore
                                    } }}</span>
                                }
                                @if (deniedByLimit()) {
                                    <span>{{ "QUOTE.CREDIT_CHECK.DENIED_REASON_LIMIT" | translate: {
                                        total: (currentTotal() | coreCurrency: cc.currencyCode),
                                        limit: (cc.creditLimit | coreCurrency: cc.currencyCode)
                                    } }}</span>
                                }
                            }
                            <span>{{ "QUOTE.CREDIT_CHECK.DENIED_MESSAGE" | translate }}</span>
                        </div>
                    </p-message>
                </div>
                <p-message severity="warn" styleClass="w-full mt-3">
                    {{ "QUOTE.CREDIT_CHECK.DENIED_OVERRIDE_HINT" | translate }}
                </p-message>
                <div class="py-5 flex justify-content-center flex-wrap gap-2">
                    <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="cancel()" />
                    <!-- Inside the report cache window a re-run returns the identical score and limit,
                             so offering it would promise a fresh answer it cannot deliver. -->
                    @if (rerunHitsProvider()) {
                        <p-button [label]="'QUOTE.CREDIT_CHECK.RERUN' | translate" severity="secondary"
                                  [outlined]="true" (onClick)="runCheck()" />
                    }
                    <p-button [label]="'QUOTE.CREDIT_CHECK.OVERRIDE' | translate" severity="danger"
                              [outlined]="true" (onClick)="overrideAndProceed()" />
                </div>
            }

            <!-- Error: a failed lookup is not a denial, so the user may continue -->
            @case ("error") {
                <div class="pt-5 text-center">
                    <i class="pi pi-exclamation-triangle text-3xl text-orange-500 mb-3 block"></i>
                    <h3 class="m-0 mb-2">
                        {{ (isNotFound() ? "QUOTE.CREDIT_CHECK.ERROR_NOT_FOUND_TITLE"
                                         : "QUOTE.CREDIT_CHECK.ERROR_TITLE") | translate }}
                    </h3>
                    <div class="subtext">
                        {{ (isNotFound() ? "QUOTE.CREDIT_CHECK.ERROR_NOT_FOUND_MESSAGE"
                                         : "QUOTE.CREDIT_CHECK.ERROR_MESSAGE") | translate }}
                    </div>
                </div>
                <div class="py-5 flex justify-content-center flex-wrap gap-2">
                    <p-button [label]="'ABORT' | translate" [text]="true" (onClick)="cancel()" />
                    <p-button [label]="'QUOTE.CREDIT_CHECK.RERUN' | translate" severity="secondary"
                              [outlined]="true" (onClick)="runCheck()" />
                    <p-button [label]="'QUOTE.CREDIT_CHECK.CONTINUE' | translate" (onClick)="onProceed()" />
                </div>
            }
        }
    </div>
</div>
